// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"p8-z"};